/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_Done_TitleInputs */



/**
* | output |
* | --- |
* | "Completed action points" |
*
* @param {Meeting_Prep_Actions_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_title = /** @type {((inputs?: Meeting_Prep_Actions_Done_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Afgeronde actiepunten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points d'action terminés")
	return /** @type {LocalizedString} */ ("Completed action points")
});